/**
 * Legacy Reactions — Constants
 *
 * Six meaningful gestures for family content.
 * Design paradigm: "Gathered, not counted."
 *
 * Order is sacred — never reorder by count or popularity.
 */

export const LEGACY_REACTIONS = [
  {
    type: 'candle',
    label: 'Lit a candle',
    description: 'This illuminated something in me',
    color: '#E6A817',
    colorLight: '#FFF8E1',
  },
  {
    type: 'seedling',
    label: 'Planted a seed',
    description: "Wisdom I'll carry forward",
    color: '#556B2F',
    colorLight: '#E8F0DC',
  },
  {
    type: 'embrace',
    label: 'Held close',
    description: 'This one stays with me',
    color: '#C67A4A',
    colorLight: '#FFF0E6',
  },
  {
    type: 'echo',
    label: 'Echoes in me',
    description: "I've lived something like this",
    color: '#7B6BA4',
    colorLight: '#F0ECF5',
  },
  {
    type: 'bookmark',
    label: 'Bookmarked',
    description: 'Coming back to this one',
    color: '#4A6741',
    colorLight: '#EDF4EC',
  },
  {
    type: 'passit',
    label: 'Passing it on',
    description: 'Sharing this wisdom forward',
    color: '#E65100',
    colorLight: '#FFF3E0',
  },
]

// Quick lookup by type
export const REACTION_MAP = Object.fromEntries(
  LEGACY_REACTIONS.map((r) => [r.type, r])
)

// Valid reaction type values
export const REACTION_TYPES = LEGACY_REACTIONS.map((r) => r.type)

// Adaptive prompt text per content type
export const CONTENT_TYPE_PROMPTS = {
  story: 'How did this story reach you?',
  memory: 'How did this memory reach you?',
  milestone: 'How did this milestone reach you?',
  time_capsule: 'How did this letter reach you?',
}

// Emoji icons for v1 (upgrade to SVG later)
export const REACTION_ICONS = {
  candle: '\uD83D\uDD6F\uFE0F',
  seedling: '\uD83C\uDF31',
  embrace: '\uD83E\uDEF6',
  echo: '\uD83D\uDD14',
  bookmark: '\uD83D\uDD16',
  passit: '\uD83E\uDEF2',
}
